import React, { useRef, useEffect } from 'react';
import { useField } from '@unform/core';
import { Container, Label, StyledInput, Error } from './styles';


interface InputProps {
  name: string;
  label?: string;
  placeholder?: string;
}



const Input: React.FC<InputProps> = ({ name, label, placeholder }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container>
      {label && <Label htmlFor={fieldName}>{label}</Label>}
      <StyledInput
        id={fieldName}
        ref={inputRef}
        defaultValue={defaultValue}
        placeholder={placeholder}
        isErrored={!!error}
      />
      {error && <Error>{error}</Error>}
    </Container>
  );
};

export default Input;
